import { Routes, Route } from 'react-router-dom'
import { Role } from 'models'
import { PrivateRoute } from 'components/PrivateRoute'
import { NotFoundPage } from 'components/NotFoundPage'
import { CommingSoonPage } from 'components/CommingSoonPage'

import {
  CreateOrder,
  EditOrder,
  ListOrders,
  ShowConnectivityOrder,
  ShowHardwareOrder
} from 'modules/Orders'
import {
  CreateSubscription,
  EditSubscription,
  ListSubscriptions,
  ShowSubscription
} from 'modules/Subscriptions'
import { ListPlans, CreatePlan, EditPlan, ViewPlan } from 'modules/Plans'
import {
  ListProducts,
  CreateProduct,
  EditProduct,
  ViewProduct
} from 'modules/Products'
import { ListStaff, ViewStaff, EditStaff, CreateStaff } from 'modules/Staff'
import { ListChips, CreateChips } from 'modules/Items/Chips'
import { ListDevices, CreateDevices } from 'modules/Items/Devices'
import {
  ListCoupons,
  ShowCoupon,
  CreateCoupon,
  EditCoupon
} from 'modules/Coupons'
import {
  ListAccess,
  CreateAccess,
  EditAccess,
  ViewAccess
} from 'modules/AccessPlans'
import { CreateClient, ListClients, ViewClient } from 'modules/Clients'
import { ClientViewProvider } from 'modules/Clients/contexts/ClientViewContext'
import { StaffViewProvider } from 'modules/Staff/contexts/StaffViewContext'
import { ClientEditProvider } from 'modules/Clients/contexts/ClientEditContext'
import { StaffEditProvider } from 'modules/Staff/contexts/StaffEditContext'
import { PlanViewProvider } from 'modules/Plans/contexts/PlanViewContext'
import { AccessPlanViewProvider } from 'modules/AccessPlans/contexts/AccessPlanViewContext'
import { ListUsersByClients } from 'modules/LoginAsClient'
import { ListInvoices, ShowInvoice } from 'modules/Invoices'

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute>
            <CommingSoonPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/plans"
        element={
          <PrivateRoute>
            <ListPlans />
          </PrivateRoute>
        }
      />
      <Route
        path="/plans/create"
        element={
          <PrivateRoute roles={[]}>
            <CreatePlan />
          </PrivateRoute>
        }
      />
      <Route
        path="/plans/:planId"
        element={
          <PrivateRoute>
            <EditPlan />
          </PrivateRoute>
        }
      />
      <Route
        path="/plans/:planId/view/general"
        element={
          <PrivateRoute>
            <PlanViewProvider>
              <ViewPlan />
            </PlanViewProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/products"
        element={
          <PrivateRoute>
            <ListProducts />
          </PrivateRoute>
        }
      />
      <Route
        path="/products/create"
        element={
          <PrivateRoute roles={[Role.MANAGER]}>
            <CreateProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/products/:productId"
        element={
          <PrivateRoute roles={[Role.MANAGER]}>
            <EditProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/products/:productId/view"
        element={
          <PrivateRoute>
            <ViewProduct />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff-members"
        element={
          <PrivateRoute>
            <ListStaff />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff-members/create"
        element={
          <PrivateRoute roles={[Role.MANAGER]}>
            <CreateStaff />
          </PrivateRoute>
        }
      />
      <Route
        path="/staff-members/:staffId/view/:viewTab"
        element={
          <PrivateRoute>
            <StaffViewProvider>
              <ViewStaff />
            </StaffViewProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/staff-members/:staffId/edit/:editTab"
        element={
          <PrivateRoute>
            <StaffEditProvider>
              <EditStaff />
            </StaffEditProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/access-plans"
        element={
          <PrivateRoute>
            <ListAccess />
          </PrivateRoute>
        }
      />
      <Route
        path="/access-plans/create"
        element={
          <PrivateRoute roles={[]}>
            <CreateAccess />
          </PrivateRoute>
        }
      />
      <Route
        path="/access-plans/:accessId"
        element={
          <PrivateRoute>
            <EditAccess />
          </PrivateRoute>
        }
      />
      <Route
        path="/access-plans/:accessId/view/general"
        element={
          <PrivateRoute>
            <AccessPlanViewProvider>
              <ViewAccess />
            </AccessPlanViewProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/clients"
        element={
          <PrivateRoute>
            <ListClients />
          </PrivateRoute>
        }
      />
      <Route
        path="/clients/create"
        element={
          <PrivateRoute roles={[Role.MANAGER, Role.FINANCE, Role.SALES]}>
            <CreateClient />
          </PrivateRoute>
        }
      />
      <Route
        path="/clients/:clientId/:clientTab"
        element={
          <PrivateRoute>
            <ClientViewProvider>
              <ClientEditProvider>
                <ViewClient />
              </ClientEditProvider>
            </ClientViewProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/invoices"
        element={
          <PrivateRoute>
            <ListInvoices />
          </PrivateRoute>
        }
      />
      <Route
        path="/invoices/:invoiceId"
        element={
          <PrivateRoute>
            <ShowInvoice />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupons"
        element={
          <PrivateRoute>
            <ListCoupons />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupons/create"
        element={
          <PrivateRoute>
            <CreateCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupons/:couponId/view/general"
        element={
          <PrivateRoute>
            <ShowCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="/coupons/:couponId"
        element={
          <PrivateRoute>
            <EditCoupon />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <PrivateRoute>
            <ListOrders />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <PrivateRoute>
            <ListSubscriptions />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/create"
        element={
          <PrivateRoute roles={[Role.MANAGER, Role.SALES]}>
            <CreateOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscriptions/create"
        element={
          <PrivateRoute roles={[Role.MANAGER, Role.SALES]}>
            <CreateSubscription />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/:orderId"
        element={
          <PrivateRoute>
            <EditOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/:orderId/chips"
        element={
          <PrivateRoute>
            <ShowConnectivityOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/orders/:orderId/devices"
        element={
          <PrivateRoute>
            <ShowHardwareOrder />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscriptions/:subscriptionId"
        element={
          <PrivateRoute>
            <EditSubscription />
          </PrivateRoute>
        }
      />
      <Route
        path="/subscriptions/:subscriptionId/view"
        element={
          <PrivateRoute>
            <ShowSubscription />
          </PrivateRoute>
        }
      />
      <Route
        path="/chips"
        element={
          <PrivateRoute>
            <ListChips />
          </PrivateRoute>
        }
      />
      <Route
        path="/chips/create"
        element={
          <PrivateRoute>
            <CreateChips />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices"
        element={
          <PrivateRoute>
            <ListDevices />
          </PrivateRoute>
        }
      />
      <Route
        path="/devices/create"
        element={
          <PrivateRoute>
            <CreateDevices />
          </PrivateRoute>
        }
      />
      <Route
        path="/support"
        element={
          <PrivateRoute
            roles={[Role.SUPPORT, Role.MANAGER, Role.SALES, Role.LOGISTICS]}
          >
            <ListUsersByClients />
          </PrivateRoute>
        }
      />
      <Route
        path="*"
        element={
          <PrivateRoute>
            <NotFoundPage />
          </PrivateRoute>
        }
      />
    </Routes>
  )
}
